import React from "react";
import { useTranslation } from "react-i18next";
import { PageLayout } from "src/components";

import "./not-found.scss";

const NotFound: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  
  return (
    <PageLayout centered fullHeight>
      <div className="not-found-content">
        <div className="not-found-icon">
          <span className="not-found-icon-emoji">🔍</span>
        </div>
        <h1 className="not-found-title">{t("NOT_FOUND.404")}</h1>
        <p className="not-found-message">{t("NOT_FOUND.PAGE_NOT_FOUND")}</p>
      </div>
    </PageLayout>
  );
};

export default NotFound;
